<template>
  <div class="header">
    <!-- <div class="content">
      {{ ranName }}
    </div> -->
    <div class="logo">
      <img style="width: 15%;" src="../assets/ran-logo.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderView',
  computed: {
    ranName () {
      return process.env.VUE_APP_RAN_NAME
    }
  }
}
</script>

<style lang="scss">
.header {
  align-content: center;
  padding: 16px;

  .content {
    margin: 0;
    font-size: 24px;
    color: white;
    text-align: center;
  }

  .logo {
    position: relative; 
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>